import * as React from 'react';
import type { SVGProps } from 'react';
const FallbackImageImagePanoramic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 470 260"
    data-xds="FallbackImageImagePanoramic"
    {...props}
  >
    <g clipPath="url(#clip0_9436_681)">
      <path fill="#F4F4F5" d="M0 0h470v260H0z" />
      <path
        fill="#DBE2E6"
        d="M106.35 178.43c-11.11-9.18-27.46-8.12-37.29 2.43L0 254.951V260h470V.5h-2.137L357.87 107.18c-8.15 7.91-21.54 6.24-27.49-3.44l-6.2-10.08c-8.98-14.59-29.02-17.38-41.64-5.8L164.6 196.07c-10.02 9.2-25.29 9.59-35.78.93zM111.52 69.15c10.863 0 19.67-8.807 19.67-19.67s-8.807-19.67-19.67-19.67-19.67 8.807-19.67 19.67 8.807 19.67 19.67 19.67M41.33 189.91H23.11v2h18.22z"
      />
      <path
        fill="#DBE2E6"
        d="M137.19 172.96h-19.28v2h19.28zM176.75 191.35h-37.03v2h37.03zM27.86 218.75H6.83v2h21.03zM85.33 179.69H52.62v2h32.71zM200.06 158.39v-16.12l-35-35c-4.56-4.56-11.96-4.56-16.52 0l-27.92 27.92c-4.56 4.56-11.96 4.56-16.52 0l-28.32-28.32c-4.56-4.56-11.96-4.56-16.52 0s-11.96 4.56-16.52 0L.67 64.79v93.6z"
      />
      <path
        fill="#ACB8CA"
        d="M395.33 229.93c14.19-11.23 44.4 9.92 47.36-13.75 2.814-22.505 3.007-61.202 27.31-64.31V260h-85.066c-.736-5.226-1.673-20.514 10.396-30.07"
      />
      <path
        fill="#DBE2E6"
        d="m461.328 184.685-3.059 78.177 1.998.079 3.059-78.178z"
      />
      <path
        fill="#DBE2E6"
        d="M454.924 191.586 453.51 193l7.347 7.347 1.414-1.414zM466.148 213.079l-6.187 6.187 1.414 1.414 6.187-6.187zM449.89 237.163l-1.414 1.414 10.826 10.826 1.414-1.415zM404.312 243.258l-1.739.988 9.662 17.008 1.739-.988zM425.01 236.208l-3.1 22.801 1.982.269 3.099-22.801z"
      />
      <path
        fill="#ACB8CA"
        d="M350.03 260.97h-44.52V224l22.09-21.2 22.43 21.2z"
      />
      <path
        fill="#DBE2E6"
        d="M325.57 260.79h-10.81v-16.21c0-2.99 2.42-5.4 5.4-5.4 2.99 0 5.4 2.42 5.4 5.4v16.21zM334.48 239.09a7.86 7.86 0 1 0 0-15.72 7.86 7.86 0 0 0 0 15.72"
      />
      <path
        fill="#ACB8CA"
        d="m267.84 260.81-2-.01.05-37.9 21.74-20.32h39.97v2h-39.18l-20.53 19.18z"
      />
      <path
        fill="#ACB8CA"
        d="M310.09 222.99h-43.3v2h43.3zM298.68 231.17H275.7v24.31h22.98zM247.62 259.68h-75.98l12.41-158.99h51.16zM187.13 87.27c0-12.42 10.07-22.5 22.5-22.5 12.42 0 22.5 10.07 22.5 22.5z"
      />
      <path
        fill="#ACB8CA"
        d="M199.89 86.62h-2v14.86h2zM206.94 86.62h-2v14.86h2zM214 86.62h-2v14.86h2zM221.05 86.62h-2v14.86h2zM228.11 86.62h-2v14.86h2zM192.83 86.62h-2v14.86h2z"
      />
      <path
        fill="#DBE2E6"
        d="M219.96 259.85h-20.57v-20.12c0-5.68 4.6-10.28 10.28-10.28s10.28 4.6 10.28 10.28v20.12z"
      />
      <path fill="#ACB8CA" d="M210.62 56.63h-2v22.32h2z" />
      <path
        fill="#DBE2E6"
        d="m237.858 117.235-55.83.273.009 2 55.83-.273zM239.38 139.72h-58.87v2h58.87zM241.96 184.41h-64.61v2h64.61zM243.71 206.75H175.7v2h68.01zM209.67 177.4a6.8 6.8 0 0 1-6.8-6.8v-15.4a6.8 6.8 0 0 1 13.6 0v15.4c0 3.76-3.04 6.8-6.8 6.8"
      />
      <path
        fill="#ACB8CA"
        d="m235.1 102.06-1.86-.73 2.73-6.91h-51.88l1.92 7.01-1.93.53-2.61-9.54h57.44zM144.29 228.28h-2v34.19h2z"
      />
      <path
        fill="#ACB8CA"
        d="m134.92 237.45-1.41-1.42 9.78-9.78 9.79 9.78-1.42 1.42-8.37-8.37z"
      />
      <path
        fill="#ACB8CA"
        d="m134.92 246.89-1.41-1.41 9.78-9.79 9.79 9.79-1.42 1.41-8.37-8.37z"
      />
      <path
        fill="#ACB8CA"
        d="m134.92 255.55-1.41-1.42 9.78-9.78 9.79 9.78-1.42 1.42-8.37-8.37zM27.56 228.28h-2v34.19h2z"
      />
      <path
        fill="#ACB8CA"
        d="m18.19 237.45-1.42-1.42 9.79-9.78 9.78 9.78-1.41 1.42-8.37-8.37z"
      />
      <path
        fill="#ACB8CA"
        d="m18.19 246.89-1.42-1.41 9.79-9.79 9.78 9.79-1.41 1.41-8.37-8.37z"
      />
      <path
        fill="#ACB8CA"
        d="m18.19 255.55-1.42-1.42 9.79-9.78 9.78 9.78-1.41 1.42-8.37-8.37zM103.43 228.28h-2v34.19h2z"
      />
      <path
        fill="#ACB8CA"
        d="m94.06 237.45-1.41-1.42 9.78-9.78 9.79 9.78-1.42 1.42-8.37-8.37z"
      />
      <path
        fill="#ACB8CA"
        d="m94.06 246.89-1.41-1.41 9.78-9.79 9.79 9.79-1.42 1.41-8.37-8.37z"
      />
      <path
        fill="#ACB8CA"
        d="m94.06 255.55-1.41-1.42 9.78-9.78 9.79 9.78-1.42 1.42-8.37-8.37zM64.95 239.77h-2v22.7h2z"
      />
      <path
        fill="#ACB8CA"
        d="m55.58 248.94-1.42-1.41 9.79-9.79 9.78 9.79-1.41 1.41-8.37-8.37z"
      />
      <path
        fill="#ACB8CA"
        d="m55.58 258.38-1.42-1.41 9.79-9.78 9.78 9.78-1.41 1.41-8.37-8.37z"
      />
      <path fill="#DBE2E6" d="M12.9 244.38H.75v2H12.9z" />
    </g>
    <defs>
      <clipPath id="clip0_9436_681">
        <path fill="#fff" d="M0 0h470v260H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default FallbackImageImagePanoramic;
